import Link from 'next/link'

export default function LeftNavItem({label, icon, url, active}) {

    return (
        <Link href={`#${url.query.nav}`} passHref>
            <a className={`${active ? 'border-b-gold' : 'hover:border-b-gold border-b-transparent '} border-b-4 my-2 max-w-max`}>
                <div className='flex'>
                    {icon ? (
                        <div className="mr-3 w-[24px] h-[24px] mt-1">
                            {icon}
                        </div>
                    ) : null}
                    <h3
                        className={`text-sm w-fit tracking-[0.04em] py-2 uppercase text-gray-dark`}>
                        {label}
                    </h3>
                </div>
            </a>
        </Link>
    );
}


